import { css, cx } from "@emotion/css";
import { space } from "@octopusdeploy/design-system-tokens";
import * as React from "react";
interface ProjectTemplateCardListProps {
    children: React.ReactNode;
}
const ProjectTemplateCardList = (props: ProjectTemplateCardListProps) => {
    return (<ol className={cx({
            [projectTemplateCardStyles]: true,
            [fixedWidthColumns]: React.Children.count(props.children) < 3,
        })}>
            {props.children}
        </ol>);
};
export default ProjectTemplateCardList;
const projectTemplateCardStyles = css({
    containerType: "inline-size",
    containerName: "projectTemplateCardList",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gridAutoRows: "260px",
    gap: space[24],
});
const fixedWidthColumns = css({
    "&&": {
        gridTemplateColumns: "repeat(auto-fit, minmax(240px, 348px))",
    },
});
